export const getActiveQueueName = state => state.toasterReducer.queue.active
export const getActiveQueue = (state) => {
    const queue = getActiveQueueName(state)
    return state.toasterReducer.queue[queue]
}
export const getButtonEnabled = (state) => {
    const activeQueue = getActiveQueue(state)
    return activeQueue.buttonEnabled
}
export const getVisible = (state) => {
    const activeQueue = getActiveQueue(state)
    return activeQueue.visible
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/queue/selectors.js